import { PopoverPlacement } from "@idui/react-popover";
import { FC, useMemo } from "react";

import { IPriceAdditionDataModel } from "@ryde/shared";

import { FramerTooltip } from "../../common";
import { useDecorateWithMark } from "../../utils";
import { IRenderColumnTemplate } from "./_core";

export const PriceRatePricingCellTemplate: FC<IRenderColumnTemplate> = ({
  id,
  value,
  name,
  formFieldTypeId,
  e2eData,
}) => {
  const { decorateValue } = useDecorateWithMark();
  const valueTyped = value as IPriceAdditionDataModel | undefined;
  let printedValue = valueTyped?.defaultPrice ?? "0";

  if (valueTyped?.prices?.length) {
    printedValue += ` + ${valueTyped?.prices.length}`;
  }

  const highlightedValue = useMemo(() => {
    return decorateValue(printedValue);
  }, [printedValue, decorateValue]);

  return (
    <FramerTooltip content={printedValue} placement={PopoverPlacement.bottom}>
      <div
        className="cell_simple"
        data-e2e-custom={e2eData}
        data-e2e-id={`${name}_fieldid_${formFieldTypeId}`}
        data-e2e-value={printedValue}
        data-e2e-template="pricing-cell"
        data-e2e-custom-field-id={id}
      >
        <span>{highlightedValue}</span>
      </div>
    </FramerTooltip>
  );
};
